import axios from "axios";

export default class MeasurementService {
    fetchMeasurements(patientId, params = {}) {
        return axios.get(`/v2/patients/${patientId}/measurements`, {params});
    }

    saveMeasurement(patientId, measurement) {
        return axios.post(`/v2/patients/${patientId}/measurements`, measurement);
    }

    updateMeasurement(patientId, measurement) {
        return axios.patch(`/v2/patients/${patientId}/measurements/${measurement.id}`, measurement);
    }

    deleteMeasurement(patientId, measurementId, params = {}) {
        return axios.delete(`/v2/patients/${patientId}/measurements/${measurementId}`, params);
    }
}
